import { useWithdrawAction } from '#/features/withdraw/useWithdrawAction';
import { useTranslation } from '#/features/localization/utils';

import Button from '#/components/shared/Button';

export default function WithdrawButton() {
  const withdrawAction = useWithdrawAction();
  const { t } = useTranslation();

  return (
    <Button
      onClick={withdrawAction.execute}
      disabled={withdrawAction.isDisabled}
    >
      {t('Withdraw')}
    </Button>
  );
}
